module.exports = __webpack_public_path__ + "static/img/WEB請求書.72889b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain1/WEB請求書.png
// module id = Yjjt
// module chunks = 0